module.exports = __webpack_public_path__ + "img/stock6.a95f79c6.png";